import * as S from './styles';

import PanelOptionMixin from '../mixin';

import Switch from '@components/Common/Switch';

import TransposeTableIcon from '@svgIcons/table_transpose.svg';
import InfoLineIcon from '@svgIcons/widget_info.svg';

import { PANEL_OPTION_KEYS } from '@/utils/consts';
import { isValueExist } from '@/utils/utils';

const { COMPARISON_BY_DATE } = PANEL_OPTION_KEYS;

export default {
    name: 'TableTransposeToggleOption',
    mixins: [PanelOptionMixin],
    props: {
        isTransposed: { type: Boolean, default: false },
        columnDimensionIds: Array,
    },
    methods: {
        renderDialog(value) {
            return this.dialog({
                confirmText: this.$t('COMMON.confirm'),
                text: this.$t(
                    'NEW_DASHBOARD.force_comparison_by_date_off_desc'
                ),
                confirmCb: () => {
                    this.$emit('updateByKey', {
                        key: COMPARISON_BY_DATE,
                        value: false,
                    });

                    this.$emit('updateColumnDimensionIds', []);

                    this.$emit('update', value);
                },
            });
        },
    },
    render() {
        const { isTransposed, comparisonByDate, columnDimensionIds } = this;

        return (
            <S.ComponentWrapper>
                <div class="top-wrapper">
                    <div class="title">
                        <TransposeTableIcon v-view-box class="option-icon" />
                        <h1>
                            {this.$t(
                                'NEW_DASHBOARD.table_transpose_toggle_option_title'
                            )}
                        </h1>
                        {this.wrapTooltip({
                            visible: true,
                            content: <InfoLineIcon class="info-line-icon" />,
                            title: this.$t(
                                'NEW_DASHBOARD.table_transpose_toggle_option_info'
                            ),
                        })}
                    </div>
                    <Switch
                        value={isTransposed}
                        type="big"
                        onClick={() => {
                            const value = !isTransposed;

                            if (
                                value &&
                                (comparisonByDate ||
                                    isValueExist(columnDimensionIds))
                            ) {
                                return this.renderDialog(value);
                            }

                            this.$emit('update', value);
                        }}
                    />
                </div>
            </S.ComponentWrapper>
        );
    },
};
